/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { DataService } from 'app/shared/services/data.service';
import { Injectable } from '@angular/core';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiResponseSummary } from 'app/shared/models/api-info.model';
import { RefundFormModel } from '../models/refund-form.model';
@Injectable({ providedIn: 'root' })
export class RefundFormService extends DataService<any> {
	constructor(apiDependencies: ApiDependenciesService) {
		super(apiDependencies);
	}

	//#region endpoints
	createRefundEndpoint(itemId: number): string {
		return `/orders/${itemId}/refund`;
	}
	getRefundFormEndpoint(itemId: number): string {
		return `/orders/${itemId}/refund-form`;
	}

	//#endregion

	async createRefund(itemId: number, dataToUpdate: any): Promise<ApiResponseSummary<any>> {
		return await this.updateItem(itemId, dataToUpdate, this.createRefundEndpoint(itemId));
	}

	async getRefundForm(itemId: number): Promise<ApiEntity> {
		let model: ApiEntity;
		await this.setEndpoint(this.getRefundFormEndpoint(itemId))
			.getSingle()
			.then((response: any) => {
				model = response;
			});
		return Promise.resolve(model);
	}
	async getSingleItem(itemId: number, dataToUpdate: any, endpoint: string) {
		console.log(endpoint);
		await this.setEndpoint(endpoint)
			.getSingle()
			.then((response) => {});
	}

	async updateItem(itemId: number, dataToUpdate: any, endpoint: string): Promise<ApiResponseSummary<any>> {
		let result: ApiResponseSummary<any>;
		this.startBlockUI();
		await this.setEndpoint(endpoint)
			.update(dataToUpdate)
			.then((response) => {
				result = response;
				if (result.success === true) {
				}
			})
			.finally(() => {
				this.stopBlockUI();
			});
		return Promise.resolve(result);
	}

	async saveItem(dataToUpdate: any, endpoint: string): Promise<ApiResponseSummary<any>> {
		let result: ApiResponseSummary<any>;
		await this.setEndpoint(endpoint)
			.save(dataToUpdate)
			.then((response) => {
				result = response;
				if (result.success === true) {
				}
			});
		return Promise.resolve(result);
	}

	async calculateRefundTotals(id: number, model: { payInFullTickets: any; paymentPlanTickets: any; processingFeeRefundType: any; dispatchMethodRefundType: any; cancellationProtectionRefundType: any; charityDonationRefundType: any }) {
		let result: RefundFormModel;

		await this.setEndpoint(this.createRefundEndpoint(id) + '/calculate-refund')
			.update(model)
			.then((response) => {
				result = response.data;
			});
		return Promise.resolve(result);
	}
}
